export default "__VITE_ASSET__f6c86595__"